/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTypesControllerFindOneQueryResponse, ProjectTypesControllerFindOnePathParams, ProjectTypesControllerFindOneQueryParams, ProjectTypesControllerFindOne400, ProjectTypesControllerFindOne401, ProjectTypesControllerFindOne403, ProjectTypesControllerFindOne404 } from "../../models/projectTypesController/ProjectTypesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectTypesControllerFindOne } from "../../clients/project-typesService/projectTypesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectTypesControllerFindOneQueryKey = (id: ProjectTypesControllerFindOnePathParams["id"], params: ProjectTypesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/project-types/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ProjectTypesControllerFindOneQueryKey = ReturnType<typeof projectTypesControllerFindOneQueryKey>;
export function projectTypesControllerFindOneQueryOptions(id: ProjectTypesControllerFindOnePathParams["id"], params?: ProjectTypesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectTypesControllerFindOneQueryKey(id, params);
  return queryOptions<ProjectTypesControllerFindOneQueryResponse, ResponseErrorConfig<ProjectTypesControllerFindOne400 | ProjectTypesControllerFindOne401 | ProjectTypesControllerFindOne403 | ProjectTypesControllerFindOne404>, ProjectTypesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectTypesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a project type by ID
 * {@link /api/v1/project-types/:id}
 */
export function useProjectTypesControllerFindOne<TData = ProjectTypesControllerFindOneQueryResponse, TQueryData = ProjectTypesControllerFindOneQueryResponse, TQueryKey extends QueryKey = ProjectTypesControllerFindOneQueryKey>(id: ProjectTypesControllerFindOnePathParams["id"], params?: ProjectTypesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectTypesControllerFindOneQueryResponse, ResponseErrorConfig<ProjectTypesControllerFindOne400 | ProjectTypesControllerFindOne401 | ProjectTypesControllerFindOne403 | ProjectTypesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectTypesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...projectTypesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectTypesControllerFindOne400 | ProjectTypesControllerFindOne401 | ProjectTypesControllerFindOne403 | ProjectTypesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}